import BankTransferInfoSvg from '@assets/images/svg/bank-transfer-info.svg';
import React from 'react';
import { View } from 'react-native';

/** Figma outline info (19×19) — bank transfer note row */
export interface BankTransferInfoIconProps {
  size?: number;
  color?: string;
}

/**
 * Stroke sits on the path edge; keep overflow visible so the circle isn’t clipped.
 */
export function BankTransferInfoIcon({
  size = 19,
  color = '#922A22',
}: Readonly<BankTransferInfoIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'visible',
        flexShrink: 0,
      }}
    >
      <BankTransferInfoSvg width={size} height={size} color={color} />
    </View>
  );
}

export default BankTransferInfoIcon;
